import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { ITEM_WIDTH_SP, VerticalListArrows } from '@lean-body/components/molecules/vertical_list_arrows';
import { MerchandiseComponent } from '../molecules/merchandise_component';
export const MerchandiseCarousel = ({ merchandises, classObject, itemMarginRight, itemsPadding, tracker, }) => {
    let targetMerchandises = merchandises.sort(() => Math.random() - Math.random());
    if (targetMerchandises.length >= 20) {
        targetMerchandises = targetMerchandises.slice(0, 20);
    }
    const middleIndex = Math.ceil(targetMerchandises.length / 2);
    const merchandisesA = targetMerchandises.slice(0, middleIndex);
    const merchandisesB = targetMerchandises.slice(middleIndex);
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement(VerticalListArrows, { classObject: classObject, itemsPadding: itemsPadding, itemMarginRight: itemMarginRight, itemSize: ITEM_WIDTH_SP, items: merchandisesA.map((v) => (React.createElement(MerchandiseComponent, { merchandise: v, tracker: tracker }))) }),
        React.createElement(VerticalListArrows, { classObject: classObject, itemsPadding: itemsPadding, itemMarginRight: itemMarginRight, itemSize: ITEM_WIDTH_SP, items: merchandisesB.map((v) => (React.createElement(MerchandiseComponent, { merchandise: v, tracker: tracker }))) })));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
});
